module.exports = __webpack_public_path__ + "static/media/img_warning.d9394d73.svg";